module.exports = __webpack_public_path__ + "img/advantage_3.aa0e45b6.svg";